<template>
<!-- Searchbar -->
<div class="searchbar">
    <a-input v-model:value="searchValue" placeholder="查找商品">
        <template #addonBefore>
            <img src="@/assets/3fish_rect.png" width="40"/>
        </template>
      <template #addonAfter>
        <search-outlined @click="onSearch"/>
      </template>
    </a-input>
</div>
</template>
<script>
  import { onMounted, inject, ref } from 'vue'
  import { searchItem } from '@/utils/api'
  export default {
    name: 'Searchbar',
    methods: {
      onSearch: function(){
        if(this.Valid.hasHtmlTag(this.searchValue)) {
          this.$message.warning('输入的值中含非法字符',2)
          return false
        }
        let data = {
            value: this.searchValue,
        }
        searchItem(data)
        .then(res =>{
          console.log("Search ===")
          console.log(res)
        })
        .catch((error) => {
          this.$message.warning(error.response.data.msg)
        })
      }
    },
    setup() {
      const Valid = inject('$Valid')
      var searchValue = ref('')
        onMounted(() =>{
            console.log('Searchbar component mounted')
            
        })
       
        return {
          searchValue, Valid
        }
    }
  };
</script>
<style lang="scss" scoped>
.searchbar {
    width: 100%;
    text-align:center;
    border:1px solid #5e5;
}

</style>